import { render, staticRenderFns } from "./failureopenOrder.vue?vue&type=template&id=6dcabd5c&scoped=true"
import script from "./failureopenOrder.vue?vue&type=script&lang=js"
export * from "./failureopenOrder.vue?vue&type=script&lang=js"
import style0 from "./failureopenOrder.vue?vue&type=style&index=0&id=6dcabd5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcabd5c",
  null
  
)

export default component.exports